// @flow
import {TOP_BANNERS_SIZE_CHANGED} from '../actions/topBanners';

import type {Action, TopBannersSizeChangedAction} from '../actions/topBanners';

export type State = {
    +height: number
};

const initialState = {
    height: 0
};

function sizeChanged(
    state: State,
    {payload: {height}}: TopBannersSizeChangedAction
): State {
    return {...state, height};
}

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    switch (action.type) {
        case TOP_BANNERS_SIZE_CHANGED:
            return sizeChanged(state, action);

        default:
            // Ensures we have handled every single action type
            // by casting the action to `empty` in the default case.
            // If Flow finds it possible to reach this case, the empty
            // cast will fail.
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
